import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import axios from "axios";

import Header from '../../Header';
import urls from "../../../utils/urls";
import {Spinner} from '../../../components/Loading/Spinner';
import {ajaxHandler} from "../../../utils/errors";
import {tokenHeader} from "../../../utils/headers";

import Sidebar from "./sidebar";
import AdminTable from './adminTable';
import adminColumns from './columns';

import ProviderView from './Modals/ProviderView';
import ProviderForm from './Modals/ProviderForm';
import ProviderDelete from './Modals/ProviderDelete';

import ProductView from './Modals/ProductView';
import ProductForm from './Modals/ProductForm';
import ProductDelete from './Modals/ProductDelete';

import TerminalView from './Modals/TerminalView';
import TerminalForm from './Modals/TerminalForm';
import TerminalDelete from './Modals/TerminalDelete';

import AreaView from './Modals/AreaView';
import AreaForm from './Modals/AreaForm';
import AreaDelete from './Modals/AreaDelete';

import MeterView from './Modals/MeterView';
import MeterForm from './Modals/MeterForm';
import MeterDelete from './Modals/MeterDelete';

import IslandView from './Modals/IslandView';
import IslandForm from './Modals/IslandForm';
import IslandDelete from './Modals/IslandDelete';

import ScaleView from './Modals/ScaleView';
import ScaleForm from './Modals/ScaleForm';
// import ScaleDelete from './Modals/ScaleDelete';

import AuditView from './Modals/AuditView';
import AuditForm from './Modals/AuditForm';
import AuditDelete from './Modals/AuditDelete';

import ReasonView from './Modals/ReasonView';
import ReasonForm from './Modals/ReasonForm';
// import ReasonDelete from './Modals/ReasonDelete';

import UserDelete from './Modals/UserDelete';
import UserView from './Modals/UserView';
import UserForm from './Modals/UserForm';
import paginationFactory from "react-bootstrap-table2-paginator";
import _ from "lodash";
import helpers from "../../../utils/helpers";


class Admin extends Component {

    constructor(props) {
        super(props);

        this.state = {
            title: '',
            url: '',
            button: '',
            sidebar_data: [
                {
                    name: 'Usuarios',
                    button: 'Nuevo Usuario',
                    variable: 'users',
                    url: 'user',
                    active: false,
                    viewComponent: UserView,
                    formComponent: UserForm,
                    deleteComponent: UserDelete
                },
                {
                    name: 'Proveedores',
                    button: 'Nuevo Proveedor',
                    variable: 'providers',
                    url: 'provider',
                    active: false,
                    viewComponent: ProviderView,
                    formComponent: ProviderForm,
                    deleteComponent: ProviderDelete
                }, {
                    name: 'Productos',
                    button: 'Nuevo Producto',
                    variable: 'products',
                    url: 'product',
                    active: false,
                    viewComponent: ProductView,
                    formComponent: ProductForm,
                    deleteComponent: ProductDelete
                }, {
                    name: 'Depósitos',
                    button: 'Nuevo Depósito',
                    variable: 'terminals',
                    url: 'terminal',
                    active: false,
                    viewComponent: TerminalView,
                    formComponent: TerminalForm,
                    deleteComponent: TerminalDelete
                }, {
                    name: 'Áreas de carga/descarga',
                    button: 'Nueva Área de carga/descarga',
                    variable: 'areas',
                    url: 'destinationarea',
                    active: false,
                    viewComponent: AreaView,
                    formComponent: AreaForm,
                    deleteComponent: AreaDelete
                }, {
                    name: 'Balanzas',
                    button: 'Nueva Balanza',
                    variable: 'scales',
                    url: 'truckscale',
                    active: true,
                    viewComponent: ScaleView,
                    formComponent: ScaleForm,
                    deleteComponent: null //ScaleDelete
                }, {
                    name: 'Islas de Descarga',
                    button: 'Nueva Isla de Descarga',
                    variable: 'islands',
                    url: 'loadingislands',
                    active: false,
                    viewComponent: IslandView,
                    formComponent: IslandForm,
                    deleteComponent: IslandDelete
                }, {
                    name: 'Meters',
                    button: 'Nuevo Meter',
                    variable: 'meters',
                    url: 'meters',
                    active: false,
                    viewComponent: MeterView,
                    formComponent: MeterForm,
                    deleteComponent: MeterDelete
                }, {
                    name: 'Razones de Rechazo',
                    button: 'Nueva Razón de Rechazo',
                    variable: 'reasons',
                    url: 'rejectionreasons',
                    active: false,
                    viewComponent: ReasonView,
                    formComponent: ReasonForm,
                    deleteComponent: null //ReasonDelete
                }, {
                    name: 'Motivos de Auditoría',
                    button: 'Nuevo Motivo de Auditoría',
                    variable: 'audits',
                    url: 'audit_reasons',
                    active: false,
                    viewComponent: AuditView,
                    formComponent: AuditForm,
                    deleteComponent: AuditDelete
                }
            ],
            columns: [],
            data: null,
            users: null,
            viewComponent: null,
            formComponent: null,
            deleteComponent: null,
            xhr: false,
            first_name__icontains: '',
            last_name__icontains: '',
            user: true,
            page: 1,
            count: null
        }
    }

    componentDidMount = () => {
        this.setItemActive(this.state.sidebar_data[0]);
    };

    _handleInput = (prop, value) => {
        this.setState({
            [prop]: value,
            page: 1
        }, () => this._fetchAdminData("user"));
    };

    _fetchAdminData = (type = "provider") => {
        if (this.state.xhr) {
            this.state.axiosSource.cancel('abort');
        }
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();

        this.setState({xhr: true, axiosSource: source});

        let admin_url = `${urls.API_ROOT}/api/v1/${type}/`;
        if (type === 'user') {
            this.setState({
                user: true
            })
            admin_url = this._generateNewQuery();
        } else {
            this.setState({
                user: false
            })
        }

        axios.get(admin_url, {...tokenHeader(), cancelToken: source.token})
            .then((response) => {
                if (type === 'user') {
                    this.setState({
                        data: response.data.results,
                        count: response.data.count,
                        xhr: false,
                        axiosSource: null
                    })
                } else {
                    this.setState({
                        data: response.data,
                        xhr: false,
                        axiosSource: null
                    })
                }
            })
            .catch((error) => {
                if (error.message && error.message === 'abort') {
                    return false;
                }
                this.setState({xhr: false});
                ajaxHandler(error);
            })
    };

    _generateNewQuery = () => {
        const getParams = this._generateParams();
        return `${urls.API_ROOT}/api/v1/user/${getParams}`;
    };

    _generateParams = () => {
        let params = `?paginated=true&`;
        let filters = ['first_name__icontains', 'last_name__icontains'];
        filters.forEach(filter => {
            let value = this.state[filter];
            if (value && value !== '') {
                params = `${params}${filter}=${value}&`;
            }
        });

        if(this.state.page > 1){
            params = `${params}page=${this.state.page}&`;
        }

        return params
    };

    setItemActive = (item) => {
        let side_data = [...this.state.sidebar_data];
        side_data.forEach(data => {
            data.active = (data.variable === item.variable);
        });

        this.setState({
            url: item.url,
            sidebar_data: side_data,
            title: item.name,
            button: item.button,
            columns: adminColumns[item.variable],
            data: null,
            viewComponent: item.viewComponent,
            formComponent: item.formComponent,
            deleteComponent: item.deleteComponent,
        });

        this._fetchAdminData(item.url);
    };

    _refreshTable = () => {
        this.setState({data: null}, () => this._fetchAdminData(this.state.url));
    };

    _onTableChange = (type, {page}) => {
        if(type === 'pagination'){
            this.setState({page}, () => this._fetchAdminData('user'));
        }
    }

    render() {
        const pagination = paginationFactory({
            page: this.state.page,
            sizePerPage: 20,
            hideSizePerPage: true,
            totalSize: this.state.count
        });

        return (
            <div>
                <Header active={"admin"}/>
                <div className={'row'} style={{marginTop: 70}}>
                    {!this.state.data && <Spinner/>}
                    {this.state.data &&
                    <AdminTable
                        title={this.state.title}
                        button={this.state.button}
                        data={this.state.data}
                        columns={this.state.columns}
                        viewComponent={this.state.viewComponent}
                        formComponent={this.state.formComponent}
                        deleteComponent={this.state.deleteComponent}
                        refreshAction={this._refreshTable}
                        inputAction={this._handleInput}
                        user={this.state.user}
                        pagination={this.state.user ? pagination : undefined}
                        onTableChange={this.state.user ? this._onTableChange : undefined}
                        xhr={this.state.user ? this.state.xhr : undefined}
                        first_name__icontains={this.state.first_name__icontains}
                        last_name__icontains={this.state.last_name__icontains}
                    />
                    }
                    <Sidebar data={this.state.sidebar_data} action={this.setItemActive}/>
                </div>
            </div>

        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Admin);



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Admin/admin.js